/*SYSTEM IMPORTS*/
import React from 'react'
import c from 'classnames'
// import Link from 'components/Link'
// import Logo from 'components/ui/Logo'

import Ratio from 'components/Ratio'


import './style'
import './media'

/*Images*/

const ListServices = props => (
    <div className="list-services">
        {props.children}
    </div>
)

const ServiceItem = props => (
    <div className={c("service-item", props.className)}>
        <div className="service-item__wrapper">
        <Ratio value={1.95}>
            <div className="service__photo">
                {props.image}
            </div>
        </Ratio>   
            <div className="service__text-wrapp">
                <h3>
                    {props.title}
                </h3>
                <div className="service__text">
                    {props.children}
                </div>
            </div>
        </div>
    </div>
) 

export { ServiceItem } 
export default ListServices